<template>
  <div id="OrgDetailBusiness">
    <eb-panel>
      <eb-panel-header class="panel-header" slot="header">
        <span slot="title">企业商圈</span>
      </eb-panel-header>
      <div slot="body">
        <div class="panel-body-row">
          <div class="panel-body-row-left">企业简介：</div>
          <div class="panel-body-row-right">
            <el-input v-model="orgInfo.companyProfile" class="eb-textarea" type="textarea"></el-input>
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left">官方网站：</div>
          <div class="panel-body-row-right">
            <el-input v-model="orgInfo.companyUrl"  class="eb-input panel-body-row-right"></el-input>
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left projectInfo">官方社交</div>
          <div class="panel-body-row-right">
            <span id="wbIdIconArea" v-if="orgInfo.wbId && orgInfo.wbId != ''">
              <input type="hidden" name="wbId" id="wbId" v-model="orgInfo.wbId">
              <el-tooltip :content="orgInfo.wbId" placement="top">
                <a href="javascript:void(0)" :data-title="orgInfo.wbId" @click="goWeiboPage($event, orgInfo.wbId)">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-weibo"></use>
                  </svg>
                </a>
              </el-tooltip>
              <i class="iconfont icon-shanchu" style="cursor: pointer;" @click="orgInfo.wbId = ''"></i>
            </span>
            <span v-if="orgInfo.wxId && orgInfo.wxId != ''" style="margin-left: 20px;">
              <input type="hidden" name="wxId" id="wxId" v-model="orgInfo.wxId">
              <el-tooltip :content="orgInfo.wxId" placement="top">
                <a href="javascript:void(0)" :data-title="orgInfo.wxId">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-weixin1"></use>
                </svg>
              </a>
              </el-tooltip>
              <i class="iconfont icon-shanchu" style="cursor: pointer;" @click="orgInfo.wxId = ''"></i>
            </span>
            <a @click="showEditSocialContactWindow()" style="color: red; font-weight: bold;margin-left: 20px;cursor: pointer;">添加+</a>
          </div>
        </div>
      </div>
    </eb-panel>
  </div>
</template>
<script>
import ebPanel from '@/components/common/panel/eb-panel';
import ebPanelHeader from '@/components/common/panel/eb-panel-header';
import eventBus from '@/plugins/event-bus';
import '@/assets/css/iconfont/iconfont';
export default {
  name: 'OrgDetailInfo',
  components: {
    ebPanel,
    ebPanelHeader
  },
  props: {
    orgInfo: {}
  },
  methods: {
    goWeiboPage(evt, text) {
      window.open('http://weibo.com/' + text, '_blank');
    },
    showEditSocialContactWindow() {
      let socialContact = {
        wbId: this.orgInfo.wbId,
        wxId: this.orgInfo.wxId
      };
      eventBus.$emit('showEditSocialContactWindow', socialContact);
    }
  }
};
</script>
<style scoped lang="less">
  .eb-textarea {
    height: 171px;
    width: 77.2%;
  }
  .projectInfo {
    align-items:flex-start!important;
    padding-top:8px;
  }
  .icon {
    width: 41px; height: 41px;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
</style>
